module.exports = __webpack_public_path__ + "static/man-35-d1344aaf849715bf208efbc11b348fa0.jpg";